<template>
  <div class="free-video">
    <div
      class="free-video__item"
      v-for="(item, index) in data"
      :key="index"
      @click="handleShowVideo($event, item)"
    >
      <div class="free-video__logo">
        <p></p>
      </div>
      <div class="free-video__info">
        <p class="info__title">{{ item.name ? item.name : '免费试听' + (index + 1) }}</p>
        <p class="info__name">
          {{ item.teacherName ? item.teacherName : '主讲：网校老师' }}
        </p>
      </div>
      <!-- <div class="free-video__number">
      {{item.sort}}
    </div> -->
    </div>
    <video-dialog
      :visible="videoVisible"
      :info="videoInfo"
      @close="videoVisible = false"
    />
  </div>
</template>

<script>
// import { mapMutations } from 'vuex'
// import types from '@/views/CourseDetail/store/types'
import VideoDialog from '@/components/VideoDialog'
export default {
  props: ['data'],
  data() {
    return {
      videoVisible: false,
      videoInfo: null
    }
  },
  components: {
    VideoDialog
  },
  methods: {
    // ...mapMutations({
    //   setLoboVideo: types.SET_LUBO_VIDEO
    // }),
    handleShowVideo(event, item) {
      this.videoInfo = {
        title: item.name,
        url: item.url,
        imgUrl: item.imgUrl,
      }

      this.videoVisible = true

      // 埋点
      this.$xesLogger.clickMsg({params: {
          key: 'xesLog-click-freevideo',
          clickid: '1.8.8',
          url: item.url,
          videoname: item.name
        }})
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(free-video) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 40px;
  @include e(item) {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 18px 20px;
    width: 384px;
    height: 68px;
    margin-right: 20px;
    background: #fafafa;
    cursor: pointer;
    & > div {
      display: inline-block;
    }
  }
  @include e(logo) {
    & > p {
      height: 24px;
      width: 24px;
      background: url('../images/video.png');
      background-position: 50%;
      background-size: 24px 24px;
      background-repeat: no-repeat;
      vertical-align: middle;
    }
  }
  @include e(number) {
    font-size: 12px;
    color: rgba(102, 102, 102, 1);
    line-height: 16px;
    position: absolute;
    right: 20px;
  }
  @include e(info) {
    padding: 0 12px;
    & > p {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
@include b(info) {
  @include e(title) {
    color: #333333;
  }
  @include e(name) {
    color: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/FreeVideo.vue